/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './QueryInfo';
import {
    WorkspaceCampaignListItem,
    WorkspaceCampaignListItemFromJSON,
    WorkspaceCampaignListItemFromJSONTyped,
    WorkspaceCampaignListItemToJSON,
} from './WorkspaceCampaignListItem';

/**
 * 
 * @export
 * @interface WorkspaceCampaignsResponse
 */
export interface WorkspaceCampaignsResponse {
    /**
     * 
     * @type {Array<WorkspaceCampaignListItem>}
     * @memberof WorkspaceCampaignsResponse
     */
    results: Array<WorkspaceCampaignListItem>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof WorkspaceCampaignsResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof WorkspaceCampaignsResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof WorkspaceCampaignsResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof WorkspaceCampaignsResponse
     */
    hasPreviousPage?: boolean;
}

export function WorkspaceCampaignsResponseFromJSON(json: any): WorkspaceCampaignsResponse {
    return WorkspaceCampaignsResponseFromJSONTyped(json, false);
}

export function WorkspaceCampaignsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceCampaignsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(WorkspaceCampaignListItemFromJSON)),
        'listResult': QueryInfoFromJSON(json['listResult']),
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function WorkspaceCampaignsResponseToJSON(value?: WorkspaceCampaignsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(WorkspaceCampaignListItemToJSON)),
        'listResult': QueryInfoToJSON(value.listResult),
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}

